import { createUseStyles } from "react-jss";
import { LIGHT_GRAY } from "../../../constants/colors";

const InvoiceDetailsStyles = createUseStyles({
  listing: {
    backgroundColor: LIGHT_GRAY,
    padding: "25px 30px",
    flex: 1,
  },
  pageTitle: {
    fontSize: 36,
    display: 'flex',
    alignItems: 'center'
  },
  invoiceBadgesWrap: {
    display: "grid",
    gap: '10px',
    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
    "& div.MuiAccordionDetails-root": {
      background: '#f5f5f5',
      paddingTop: 0
    },
    "& .MuiAccordionSummary-root.Mui-expanded": {
      background: '#f5f5f5',
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: 0,
    },
  },
  invoiceBadges: {
    backgroundColor: '#ffffff',
    minHeight: '100% !important',
    borderRadius: '8px',
    padding: '14px',
    margin: '0 5px',
    fontFamily: 'bogle',
    fontSize: '14px',
    textAlign: 'right'
  },
  invoiceBadgesLast: {
    marginRight: 0,
  },
  pageInfoBold: {
    fontWeight: "bold",
    '& h4': {
      fontSize: "18px"
    }
  },
  label: {
    fontSize: "14px",
  },
  header: {
    paddingLeft: 16,
  },
  tabContainer: {
    backgroundColor: "#ffffff",
    padding: "0px",
    margin: "24px 0px 24px 0px",
    "& > nav ": {
      backgroundColor: "#f5f5f5",
    },
    "& > nav >ul>li>a": {
      backgroundColor: "#f5f5f5",
    },
  },
  gridLayout: {
    display: "grid",
    gap: '15px',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    margin: '16px 10px'
  },
  icons: {
    display: "flex",
    justifyContent: "right",
    "& button": {
      marginRight: "8px"
    },
  },
  pageTitleGroup: {
    margin: "16px 10px"
  },
  pageTitleWrap: {
    display: "flex",
    alignItems: 'center'
  },
  pageTitleBadge: {
    padding: "2px 0 2px 8px",
    borderRadius: "2px",
  },
  invoiceDateSubtitle: {
    color: "#74767C",
    fontSize: "16px",
    fontWeight: "700",
    paddingTop: "8px"
  },
  contentSpacing8: {
    paddingTop: "8px"
  },
  alertStyle: {
    padding: "20px 0px 20px 0px"
  },
  groupHeading: {
    color: '#2E2F32',
    fontWeight: 'bold',
    fontSize: '18px'
  },
  groupMessage: {
    padding: "12px 0",
    fontSize: '13px'
  },
  disableTabs: {
    opacity: 0.5,
    pointerEvents: "none"
  },
  divTile: {
    display: "flex"
  },
  divMinus: {
    fontSize: "68px",
    alignSelf: "center",
  },
  divEqual: {
    fontSize: "45px",
    alignSelf: "center",
    paddingLeft: "10px"
  },
  gridLayoutTiles: {
    background: '#ffffff',
  },
  gridColumn: {
    background: '#f5f5f5',
    padding: '0 10px 10px 10px',
  },
  accordionArrow: {
    marginLeft: '10px',
    display: 'inline-block',
    transform: 'rotate(-90deg)',
    transition: '.2s ease-in-out'
  },
  wordBreak: {
    overflowWrap: 'break-word',
    margin: '0',
    whiteSpace: "break-spaces"
  },
  leftGrid: {
    paddingLeft: '5px'
  },
  resubmit: {
    marginTop: '5px'
  },
  total: {
    "margin": "5px",
    "borderTop": "1px solid #e3e4e5"
  },
  "& .MuiAccordionSummary-root.Mui-expanded": {
    background: '#f5f5f5',
  },
  progressTracker: {
    padding: "10px 0px 10px 0px"
  },
  revalidateSpinner: {
    display: 'flex',
    justifyContent: 'center',
  },
  hideModalTitle: {
    '& > div > div > div > div:first-child': {
      padding: "10px 0 !important",
      "& button": {
        display: "none",
      },
    },
    '& > div > div > div > div > div > div': {
      display: "block",
    },
  },
  revalidationTitle: {
    display: 'flex',
    justifyContent: 'center',
    fontFamily: 'Bogle',
    fontWeight: 700,
    padding: '10px'
  },
  revalidationTxt: {
    display: 'flex',
    justifyContent: 'center',
    padding: '0 40px',
    fontFamily: 'Bogle',
    fontSize: '16px',
  },
  revalidationModalTitle: {
    display: 'flex',
    fontFamily: 'Bogle',
    fontWeight: 700,
    padding: '10px 0',
    fontSize: '16px',
  },
  revalidationModalTxt: {
    display: 'flex',
    fontFamily: 'Bogle',
    fontSize: '16px',
  },
  infoButton: {
    marginTop: '8px'
  }
});

export default InvoiceDetailsStyles;
